<div class="feedback-overlay" (click)="skip()">
  <div class="feedback-card" (click)="$event.stopPropagation()">

    <!-- Header with close button -->
    <div class="feedback-header">
      <div class="header-text">
        <ion-icon name="star-outline" class="header-icon"></ion-icon>
        <h4>Come valuti la tua esperienza?</h4>
      </div>
      <ion-icon name="close" class="close-icon" (click)="skip()"></ion-icon>
    </div>

    <!-- Step 1: Rating -->
    <div *ngIf="!isSubmitted">
      <div class="stars-container">
        <ion-icon
          *ngFor="let star of stars"
          [name]="star <= rating ? 'star' : 'star-outline'"
          [class.active]="star <= rating"
          [class.hovered]="star <= rating"
          (click)="setRating(star)"
          class="star-icon"
        ></ion-icon>
      </div>

      <!-- Step 2: Conditional follow-up text -->
      <div class="follow-up" *ngIf="rating > 0">
        <!-- Critical: 1 or 2 stars -->
        <ng-container *ngIf="rating <= 2">
          <div class="prompt-bubble negative">
            <ion-icon name="sad-outline" class="prompt-icon"></ion-icon>
            <div class="bubble-text">
              <span class="bubble-title">Ci dispiace per l'esperienza negativa!</span>
              <p>Cosa suggeriresti per migliorarlo? <span class="optional">(Facoltativo)</span></p>
            </div>
          </div>
          <ion-textarea
            [(ngModel)]="suggestion"
            placeholder="Scrivi qui il tuo suggerimento (es. cosa non ha funzionato, come possiamo migliorare)..."
            [rows]="3"
            class="feedback-textarea suggestion-textarea"
            [disabled]="isSubmitting"
          ></ion-textarea>
        </ng-container>

        <!-- Neutral: 3 stars -->
        <ng-container *ngIf="rating === 3">
          <div class="prompt-bubble neutral">
            <ion-icon name="help-circle-outline" class="prompt-icon"></ion-icon>
            <div class="bubble-text">
              <p>Hai qualche commento o suggerimento per noi? <span class="optional">(Opzionale)</span></p>
            </div>
          </div>
          <ion-textarea
            [(ngModel)]="comment"
            placeholder="Scrivi qui il tuo commento..."
            [rows]="3"
            class="feedback-textarea"
            [disabled]="isSubmitting"
          ></ion-textarea>
        </ng-container>

        <!-- Positive: 4 or 5 stars -->
        <ng-container *ngIf="rating >= 4">
          <div class="prompt-bubble positive">
            <ion-icon name="happy-outline" class="prompt-icon"></ion-icon>
            <div class="bubble-text">
              <p>Ottimo! Cosa ti è piaciuto di più? <span class="optional">(Opzionale)</span></p>
            </div>
          </div>
          <ion-textarea
            [(ngModel)]="comment"
            placeholder="Scrivi qui il tuo commento..."
            [rows]="3"
            class="feedback-textarea"
            [disabled]="isSubmitting"
          ></ion-textarea>
        </ng-container>
      </div>

      <!-- Privacy + Actions -->
      <div class="privacy-note" *ngIf="rating > 0">
        <ion-icon name="shield-checkmark-outline"></ion-icon>
        <span>Feedback anonimo al 100% — nessun dato personale raccolto.</span>
      </div>

      <div class="action-row" *ngIf="rating > 0">
        <ion-button fill="clear" size="small" class="skip-btn" (click)="skip()" [disabled]="isSubmitting">
          Salta
        </ion-button>
        <ion-button size="small" class="submit-btn" (click)="submit()" [disabled]="isSubmitting">
          <ion-spinner *ngIf="isSubmitting" name="crescent" class="submit-spinner"></ion-spinner>
          <span *ngIf="!isSubmitting">Invia Feedback</span>
        </ion-button>
      </div>
    </div>

    <!-- Thank you screen -->
    <div *ngIf="isSubmitted" class="thank-you">
      <div class="success-animation">
        <ion-icon name="checkmark-circle" class="success-icon"></ion-icon>
      </div>
      <h4>Grazie mille! 🙏</h4>
      <p>Il tuo parere ci aiuta a migliorare Acuplace per tutti.</p>
      <ion-button fill="outline" size="small" (click)="close()" class="close-thanks-btn">
        Chiudi
      </ion-button>
    </div>

  </div>
</div>
